import { configureStore } from '@reduxjs/toolkit'

import AdministratorSlice from '../Slice/AdministratorSlice'
export const store = configureStore({
    reducer: {
    Administrator:AdministratorSlice
    },})